var copy = document.getElementById("copy-link")
var linkText = document.getElementById("link-text")

if(copy) {
    copy.addEventListener("click", Copy)
}

function Copy() {
  navigator.clipboard.writeText(window.location.href);
  linkText.innerHTML = 'Copied!';
  setTimeout(() => { linkText.innerHTML = 'Copy Link' }, 2000);
}

export default {};